import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LuLogIn as FiLogIn } from "react-icons/lu";
import { useNavigate } from 'react-router';
import { ROUTES } from '../App';

const SignInPopup = ({ open, onClose }) => {
    const navigate = useNavigate();

    const handleSignIn = () => {
        onClose();
        navigate(ROUTES.SIGN_IN); // Adjust this route to match your sign-in page
    };

    const handleSignUp = () => {
        onClose();
        navigate(ROUTES.SIGN_UP); // Adjust this route to match your sign-up page
    };


    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[1800] flex flex-col items-center justify-center px-4 sm:px-6"
                >
                    {/* Backdrop */}
                    <div className="absolute inset-0 bg-[#000]/70 backdrop-blur-md" />

                    {/* Welcome Heading */}
                    <motion.h1
                        initial={{ y: -20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.1 }}
                        className="absolute top-6 sm:top-10 text-2xl sm:text-4xl font-bold text-white tracking-wider"
                    >
                        Welcome
                    </motion.h1>

                    {/* Center Content */}
                    <motion.div
                        initial={{ scale: 0.92, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        transition={{ type: 'spring', stiffness: 260, damping: 22 }}
                        className="relative w-full max-w-sm sm:max-w-xl mx-auto flex flex-col items-center text-center bg-transparent"
                    >
                        <FiLogIn className="w-16 h-16 sm:w-24 sm:h-24 mb-6 sm:mb-8 text-white" />
                        <h2 className="text-white text-2xl sm:text-3xl font-semibold mb-3 sm:mb-4 tracking-wide">
                            Sign in required
                        </h2>
                        <p className="text-white/80 text-sm sm:text-base leading-relaxed max-w-md sm:max-w-xl mb-6 sm:mb-8 px-2">
                            Please sign in to join this community.
                        </p>

                        <div className="w-full space-y-3">
                            <button
                                onClick={handleSignIn}
                                className="w-full bg-[#247295] hover:bg-[#1f6787] active:scale-[0.98] transition text-white font-semibold py-3 sm:py-4 rounded-xl sm:rounded-2xl text-base sm:text-lg shadow-lg shadow-black/40"
                            >
                                Sign In
                            </button>

                            <button
                                onClick={handleSignUp}
                                className="w-full bg-transparent hover:bg-white/10 active:scale-[0.98] transition text-white font-semibold py-3 sm:py-4 rounded-xl sm:rounded-2xl text-base sm:text-lg border-2 border-white/30 hover:border-white/50"
                            >
                                Create Account
                            </button>
                        </div>

                        <button
                            onClick={onClose}
                            className="mt-4 sm:mt-6 text-white/60 hover:text-white text-xs sm:text-sm"
                        >
                            Maybe later
                        </button>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default SignInPopup;